<template>
  <div class="page-class page-vision-list">
    <h1 class="page-title">{{ title }}</h1>
    <table-box
      :columns="columns"
      :rows="visions"
      :pagination="pagination"
      :baseUrl="baseUrl"
      :loading="loading"
      emptyText="No vision found. Please add new vision."
      :showAdd="true"
      addText="Create new vision"
      @add="onAdd"
      @edit="onEdit"
      @delete="onDelete"
    >
      <template v-slot:emailAddressFormatted="slotProps">
        <span class="span-text span-block">{{ slotProps.row.email }}</span>
        <template v-if="slotProps.row.confirmedAtFormatted">
          <span
            class="text-success span-help-text"
            :title="slotProps.row.confirmedAt"
          >{{ slotProps.row.confirmedAtFormatted }}</span>
        </template>
        <template v-if="slotProps.row.confirmedAtFormatted === null">
          <span class="text-warning span-help-text">(Not confirmed)</span>
        </template>
      </template>
    </table-box>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import TableBox from '@/components/TableBox.vue';
import router from '@/router';

export default {
  name: 'VisionList',
  components: {
    TableBox
  },
  metaInfo() {
    return {
      title: 'Visions',
      meta: [
        {
          name: 'description',
          content: `Manage vision list`
        }
      ]
    };
  },
  mounted() {
    this.list({ type: 'vision', query: this.$route.query });
  },
  data() {
    return {
      title: 'Visions',
      columns: [
        {
          type: 'row_num',
          headerText: '#',
          class: { 'text-center': true },
          textKey: 'rowNum',
          width: '5%'
        },
        {
          type: 'number',
          headerText: 'Name',
          textKey: 'name',
          width: '20%'
        },
        {
          type: 'number',
          headerText: 'Score',
          textKey: 'score',
          width: '10%'
        },
        {
          type: 'string',
          headerText: 'Negative',
          textKey: 'thresholdNegative',
          width: '6%'
        },
        {
          type: 'number',
          headerText: 'Neutral',
          textKey: 'thresholdNeutral',
          width: '6%'
        },
        {
          type: 'string',
          headerText: 'Positive',
          textKey: 'thresholdPositive',
          width: '6%'
        },
        {
          type: 'datetime',
          headerText: 'Updated',
          slotKey: 'updatedAtFormatted',
          width: '15%'
        },
        {
          type: 'string',
          headerText: 'Status',
          class: { 'text-center': true },
          textKey: 'enabledName',
          width: '7%'
        },
        {
          type: 'functions',
          headerText: 'Functions',
          class: { 'text-center': true },
          width: '18%',
          functions: {
            edit: true,
            delete: true
          }
        }
      ]
    };
  },
  computed: {
    ...mapState('vision', ['loading', 'baseUrl', 'visions', 'pagination'])
  },
  methods: {
    ...mapActions('vision', ['list', 'deleteOne']),
    onAdd() {
      router.push('/vision/new');
    },
    onEdit({ row }) {
      router.push(`/vision/${row.id}`);
    },
    onDelete({ row }) {
      Vue.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this.",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',

        preConfirm: () => {
          this.deleteOne({
            type: 'vision',
            visionId: row.id
          });
        }
      });
    }
  }
};
</script>
